module.exports = __webpack_public_path__ + "img/icon2-2.f4039c79.svg";